export const avatarGroupStyles = {
  components: {
    AvatarGroup: {
      baseStyle: {
        showBorder: undefined, // Ensure `showBorder` is not propagated
      },
    },
    Avatar: {
      baseStyle: {
        showBorder: undefined, // Ensure `showBorder` is not propagated
      },
    },
  },
};
